import {toThousands} from "../../util/util"
export default {
  data () {
    return {
      selections: '',
      formData: null,
      tableData: null,
      filterdata: '',
      coverage: null,
    }
  },
  methods: {
    changeComponent () {
      this.$router.push('/sfdrreport')
    },
    // vxe-table排序事件
    sortChangeEvent ({ sortList }) {
      sortList.map((item) => `${item.property},${item.order}`).join('; ')
    },
    // 通过ticker筛选
    filterTableData(){
      if (this.filterdata=='') this.formDataRt()
      else {
        var arr = []
        for(let i = 0; i < this.tableData.length; i++){
          if(this.tableData[i].Ticker.split(this.filterdata).length > 1){
            let obj = {}
            for(let attr in this.tableData[i]){
              obj[attr] = this.tableData[i][attr]
            }
            arr.push(obj)
          }
        }
        this.tableData = arr
      }
    },

    formDataRt () {
      let array = {}
      for(let i=0;i<this.formData.length;i++){
        if(!array[this.formData[i].Ticker]){
          array[this.formData[i].Ticker] = {}
          array[this.formData[i].Ticker]['Ticker']= this.formData[i]['Ticker']
          array[this.formData[i].Ticker]['ISIN']= this.formData[i]['ISIN']
          array[this.formData[i].Ticker]['short_name']= this.formData[i]['short_name']
        }
        let attr = this.formData[i]['report_date']===this.selections.report_date?'v_1':'v_2'
        array[this.formData[i].Ticker][attr]= this.formData[i][this.coverage.data_point]
        if(array[this.formData[i].Ticker]['v_1'] && array[this.formData[i].Ticker]['v_2']){
          array[this.formData[i].Ticker]['delta'] = (100*(array[this.formData[i].Ticker]['v_1'] - array[this.formData[i].Ticker]['v_2']) / array[this.formData[i].Ticker]['v_2']).toFixed(2) + '%'
        }
      }
      let arrayRt = []
      for(let attr in array) {
        arrayRt.push(array[attr])
      }
      this.tableData = arrayRt
    }
  },
  created() {
    this.selections = JSON.parse(window.sessionStorage.getItem('sfdr'))
    this.coverage = this.$route.query.data
    if (this.selections) this.formData = JSON.parse(this.selections.rawdata)
    this.formDataRt ()
  },
  computed: {
    firstFloorReport: function () {
      return this.selections.report_date
    },
    firstFloorAUM: function () {
      let temp = this.selections.aum_reporting_date.toFixed(2)
      let b = temp.toString().split('.')
      let numbers = toThousands(b[0]) + '.' + toThousands(b[1])
      return this.selections.aum_reporting_date_currency?this.selections.aum_reporting_date_currency + ' ' + numbers : ''
    },
    firstFloorNumber: function () {
      return this.selections.num_of_cur_companies
    },
    secondFloorReport: function () {
      return this.selections.last_report_date
    },
    secondFloorAUM: function () {
      let temp = this.selections.aum_last_reporting_date.toFixed(2)
      let b = temp.toString().split('.')
      let numbers = toThousands(b[0]) + '.' + toThousands(b[1])
      return this.selections.aum_last_reporting_date_currency?this.selections.aum_last_reporting_date_currency + ' ' + numbers : ''
    },
    secondFloorNumber: function () {
      return this.selections.num_of_last_companies
    },
    tableColumn() {
      return [
        {type: 'seq', title: 'ID', width: 60},
        {field: 'Ticker', title: this.$t('common.ticker'), sortable: true},
        {field: 'ISIN', title: 'ISIN', sortable: true},
        {field: 'short_name', title: this.$t('common.company_short_name'), sortable: true, backgroundColor: 'black'},
        {field: 'v_1',
          title: 'Value',
          sortable: true,
          formatter: ({cellValue, row, column}) => {
            if (this.selections.report_date){
              if (typeof this.selections.report_date=='string')
                column.title = 'Value[' + this.selections.report_date + ']'
            }
            if(cellValue==1||cellValue==0) return cellValue
            return cellValue?cellValue.toFixed(2): cellValue
          }
        },
        {field: 'v_2',
          title: 'Value',
          sortable: true,
          formatter: ({cellValue, row, column}) => {
            if (this.selections.report_date){
              if (typeof this.selections.report_date=='string')
                column.title = 'Value[' + this.selections.last_report_date + ']'
            }
            if(cellValue==1||cellValue==0) return cellValue
            return cellValue?cellValue.toFixed(2): cellValue
          }
        },
        {field: 'delta', title: this.$t('sfdr.delta'), sortable: true, width: 200},
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/sfdr/js/sfdr_coverage_details.js